import { useState } from 'react'
import { useAsync } from 'react-use'
import { Button, Checkbox, Col, Dropdown, Form, Menu, notification, Radio, Row, Space } from 'antd'
import { MenuOutlined } from '@ant-design/icons'

import Select from '../Select'

import Styled from './styled'

import { useTranslate } from 'hooks/translate'

import { getScheduleTypeApi } from 'services/filter/scheduleType'
// import { getSummaryTypeApi } from 'services/filter/summaryType'
import { getNotificationSetupApi, patchNotificationSetupApi } from 'services/notificationSetup'

import _ from 'lodash'
import i18n from 'i18next'

export default function UserSetting() {
  const { t } = useTranslate()
  const user = JSON.parse(localStorage.getItem('user'))

  const [notificationId, setNotificationId] = useState(null)
  const [language, setLanguage] = useState('en')
  const [operationalNotifiedEvent, setOperationalNotifiedEvent] = useState([])
  const [operationalNotifiedStatus, setOperationalNotifiedStatus] = useState([])
  const [ownerNotifiedEvent, setOwnerNotifiedEvent] = useState([])
  const [ownerNotifiedStatus, setOwnerNotifiedStatus] = useState([])
  const [overDuePeriod, setOverDuePeriod] = useState(null)
  const [scheduleValue, setScheduleValue] = useState(null)
  const [summaryValue, setSummaryValue] = useState(null)

  const [ropKeyArr, setRopKeyArr] = useState([])
  const [ronKeyArr, setRonKeyArr] = useState([])
  const [ropStatusKeyArr, setRopStatusKeyArr] = useState([])
  const [ronStatusKeyArr, setRonStatusKeyArr] = useState([])

  const [ropEventsOptions, setRopEventsOptions] = useState([])
  const [ronEventsOptions, setRonEventsOptions] = useState([])
  const [ropStatusOptions, setRopStatusOptions] = useState([])
  const [ronStatusOptions, setRonStatusOptions] = useState([])
  const [scheduleOption, setScheduleOption] = useState([])
  // const [summaryOption, setSummaryOption] = useState([])

  const [showMenu, setShowMenu] = useState(false)

  const languageOptions = [
    { label: t('English'), value: 'en' },
    { label: t('Thai'), value: 'th' },
  ]

  const getScheduleType = async () => {
    const res = await getScheduleTypeApi()
    setScheduleOption(res.data)
  }

  // const getSummaryType = async () => {
  //   const res = await getSummaryTypeApi()
  //   setSummaryOption(res.data)
  // }

  const getNotificationSetup = async () => {
    const res = await getNotificationSetupApi(user.user_id)
    //Set NotificationId
    setNotificationId(res.data?.notification_setup_id)
    //Set Language
    if (res.data?.eng_language === true && res.data?.th_language === false) {
      setLanguage('en')
      i18n.changeLanguage('en')
    } else if (res.data?.eng_language === false && res.data?.th_language === true) {
      setLanguage('th')
      i18n.changeLanguage('th')
    }
    //Set Risk Operational Options
    const ropKeyArr = res.data?.rop_key
    const ropValArr = res.data?.rop_value
    if (ropKeyArr?.length > 0) {
      const ropOptions = ropKeyArr.map((key, idx) => {
        return { label: key, value: ropValArr[idx] }
      })
      setRopEventsOptions(ropOptions)
    }
    let tempRop = []
    _.map(ropValArr, (item, idx) => {
      if (item) {
        tempRop.push(ropKeyArr[idx])
      }
    })
    setOperationalNotifiedEvent(tempRop)
    setRopKeyArr(ropKeyArr)
    //Set Risk Owner Options
    const ronKeyArr = res.data?.ron_key
    const ronValArr = res.data?.ron_value
    if (ronKeyArr?.length > 0) {
      const ronOptions = ronKeyArr.map((key, idx) => {
        return { label: key, value: ronValArr[idx] }
      })
      setRonEventsOptions(ronOptions)
    }
    let tempRon = []
    _.map(ronValArr, (item, idx) => {
      if (item) {
        tempRon.push(ronKeyArr[idx])
      }
    })
    setOwnerNotifiedEvent(tempRon)
    setRonKeyArr(ronKeyArr)
    //Set Risk Operational Status
    const ropStatusKeyArr = res.data?.rop_risk_status_key
    const ropStatusValArr = res.data?.rop_risk_status_value
    if (ropStatusKeyArr?.length > 0) {
      const ropStatusOptions = ropStatusKeyArr.map((key, idx) => {
        return { label: key, value: ropStatusValArr[idx] }
      })
      setRopStatusOptions(ropStatusOptions)
    }
    let tempRopStatus = []
    _.map(ropStatusValArr, (item, idx) => {
      if (item) {
        tempRopStatus.push(ropStatusKeyArr[idx])
      }
    })
    setOperationalNotifiedStatus(tempRopStatus)
    setRopStatusKeyArr(ropStatusKeyArr)
    //Set Risk Owner Status
    const ronStatusKeyArr = res.data?.ron_risk_status_key
    const ronStatusValArr = res.data?.ron_risk_status_value
    if (ronStatusKeyArr?.length > 0) {
      const ronStatusOptions = ronStatusKeyArr.map((key, idx) => {
        return { label: key, value: ronStatusValArr[idx] }
      })
      setRonStatusOptions(ronStatusOptions)
    }
    let tempRonStatus = []
    _.map(ronStatusValArr, (item, idx) => {
      if (item) {
        tempRonStatus.push(ronStatusKeyArr[idx])
      }
    })
    setOwnerNotifiedStatus(tempRonStatus)
    setRonStatusKeyArr(ronStatusKeyArr)
    //Set Overdue Period
    setOverDuePeriod(res.data?.overdue_period)
    //Set Schedule Frequency
    setScheduleValue(res.data?.schedule_type_id)
    //Set Summary Radio Value
    setSummaryValue(res.data?.summary_type_id)
  }

  useAsync(async () => {
    getNotificationSetup()
    getScheduleType()
    // getSummaryType()
  }, [])

  const handleSubmit = async () => {
    const ln =
      language === 'en'
        ? { eng_language: true, th_language: false }
        : { eng_language: false, th_language: true }

    // operationalNotifiedEvent
    const ropEventValue = _.map(ropKeyArr, (item) => {
      if (_.includes(operationalNotifiedEvent, item)) {
        return true
      } else {
        return false
      }
    })
    // ownerNotifiedEvent
    const ronEventValue = _.map(ronKeyArr, (item, idx) => {
      if (_.includes(ownerNotifiedEvent, item)) {
        return true
      } else {
        return false
      }
    })
    // operationalNotifiedStatus
    const ropStatusValue = _.map(ropStatusKeyArr, (item, idx) => {
      if (_.includes(operationalNotifiedStatus, item)) {
        return true
      } else {
        return false
      }
    })
    // ownerNotifiedStatus
    const ronStatusValue = _.map(ronStatusKeyArr, (item, idx) => {
      if (_.includes(ownerNotifiedStatus, item)) {
        return true
      } else {
        return false
      }
    })
    const val = {
      notification_setup_id: notificationId,
      ...ln,
      rop_value: ropEventValue,
      ron_value: ronEventValue,
      rop_risk_status_value: ropStatusValue,
      ron_risk_status_value: ronStatusValue,
      overdue_period: overDuePeriod ? Number(overDuePeriod) : 0,
      schedule_type_id: scheduleValue,
      summary_type_id: summaryValue,
    }

    const res = await patchNotificationSetupApi(user.user_id, val)

    if (res.status === 'error') {
      notification.error({
        message: 'Failed',
        description: res.message,
      })
    } else {
      notification.success({
        message: 'Success',
        description: res.message,
      })
    }
  }

  const menu = (
    <Menu style={{ maxWidth: '500px' }}>
      <Menu.Item key="language">
        <Row justify="space-between" align="middle">
          <Col>Language Setup:</Col>
          <Col span={12}>
            <Select
              value={language}
              options={languageOptions}
              onChange={(value) => {
                setLanguage(value)
              }}
              style={{ width: '100%' }}
              allowClear={false}
            />
          </Col>
        </Row>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="text">
        <Row align="middle">Report and Notifications Setup:</Row>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="rop">
        <Row style={{ fontSize: '12px' }}>Risk Operational Notify</Row>
        <Row gutter={8} justify="space-between">
          <Col span={12}>
            <Select
              mode="multiple"
              allowClear
              placeholder="Select Notified Events"
              value={operationalNotifiedEvent}
              onChange={(checkedValue) => {
                if (_.includes(checkedValue, 'Status Update') === false) {
                  setOperationalNotifiedStatus([])
                }
                setOperationalNotifiedEvent(checkedValue)
              }}
              dropdownRender={() => (
                <CheckboxGroup
                  value={operationalNotifiedEvent}
                  options={ropEventsOptions}
                  onChange={(checkedValue) => {
                    if (_.includes(checkedValue, 'Status Update') === false) {
                      setOperationalNotifiedStatus([])
                    }
                    setOperationalNotifiedEvent(checkedValue)
                  }}
                />
              )}
              style={{ width: '100%' }}
              allowClear={true}
            />
          </Col>
          <Col span={12}>
            <Select
              mode="multiple"
              allowClear
              placeholder="Select Notified Status"
              value={operationalNotifiedStatus}
              onChange={(checkedValue) => setOperationalNotifiedStatus(checkedValue)}
              dropdownRender={() => (
                <CheckboxGroup
                  value={operationalNotifiedStatus}
                  options={ropStatusOptions}
                  onChange={(checkedValue) => setOperationalNotifiedStatus(checkedValue)}
                />
              )}
              style={{ width: '100%' }}
              disabled={_.includes(operationalNotifiedEvent, 'Status Update') ? false : true}
              allowClear={true}
            />
          </Col>
        </Row>
      </Menu.Item>
      <Menu.Item key="ron">
        <Row style={{ fontSize: '12px' }}>Risk Owner Notify</Row>
        <Row gutter={8} justify="space-between">
          <Col span={12}>
            <Select
              mode="multiple"
              allowClear
              placeholder="Select Notified Events"
              value={ownerNotifiedEvent}
              onChange={(checkedValue) => {
                if (_.includes(checkedValue, 'Status Update') === false) {
                  setOwnerNotifiedStatus([])
                }
                setOwnerNotifiedEvent(checkedValue)
              }}
              dropdownRender={() => (
                <CheckboxGroup
                  value={ownerNotifiedEvent}
                  options={ronEventsOptions}
                  onChange={(checkedValue) => {
                    if (_.includes(checkedValue, 'Status Update') === false) {
                      setOwnerNotifiedStatus([])
                    }
                    setOwnerNotifiedEvent(checkedValue)
                  }}
                />
              )}
              style={{ width: '100%' }}
              allowClear={true}
            />
          </Col>
          <Col span={12}>
            <Select
              mode="multiple"
              allowClear
              placeholder="Select Notified Status"
              value={ownerNotifiedStatus}
              onChange={(checkedValue) => setOwnerNotifiedStatus(checkedValue)}
              dropdownRender={() => (
                <CheckboxGroup
                  value={ownerNotifiedStatus}
                  options={ronStatusOptions}
                  onChange={(checkedValue) => setOwnerNotifiedStatus(checkedValue)}
                />
              )}
              style={{ width: '100%' }}
              disabled={_.includes(ownerNotifiedEvent, 'Status Update') ? false : true}
              allowClear={true}
            />
          </Col>
        </Row>
      </Menu.Item>
      <Menu.Item key="schedule">
        <Row style={{ fontSize: '12px' }}>Summary On-handed Report</Row>
        <Row gutter={8} justify="space-between">
          {/* <Col span={12}>
            <Input
              placeholder="Overdue Period (days)"
              value={overDuePeriod}
              onChange={(e) => setOverDuePeriod(e.target.value)}
            />
          </Col> */}
          <Col span={12}>
            <Select
              placeholder="Select Frequency"
              options={scheduleOption}
              value={scheduleValue}
              onChange={(checkedValue) => setScheduleValue(checkedValue)}
              style={{ width: '100%' }}
            />
          </Col>
        </Row>
      </Menu.Item>
      {/* <Menu.Item key="summary">
        <Row>
          <Radio.Group
            options={summaryOption}
            value={summaryValue}
            onChange={(e) => setSummaryValue(e.target.value)}
          />
        </Row>
      </Menu.Item> */}
      <Menu.Item key="submitBtn">
        <Button
          type="primary"
          onClick={() => {
            handleSubmit()
            setShowMenu(!showMenu)
          }}
        >
          {t('Submit')}
        </Button>
      </Menu.Item>
    </Menu>
  )

  return (
    <Styled className="user-setting-component">
      <Dropdown
        overlay={menu}
        visible={showMenu}
        onVisibleChange={() => setShowMenu(!showMenu)}
        trigger={['click']}
        placement="bottomRight"
        arrow
      >
        <MenuOutlined />
      </Dropdown>
    </Styled>
  )
}

// CheckboxGroup Component
const CheckboxGroup = ({ value, options, onChange }) => {
  return (
    <Checkbox.Group value={value} onChange={onChange} style={{ margin: '0 8px' }}>
      <Row>
        {options.map((item, idx) => {
          return (
            <Col span={24}>
              <Checkbox key={idx} value={item.label}>
                {item.label}
              </Checkbox>
            </Col>
          )
        })}
      </Row>
    </Checkbox.Group>
  )
}
